import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
var _excluded = ["gid"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _callSuper2(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import { Component } from 'react';
import ShopInterface from '../../api/ShopInterface';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants, { PurchaseFinishedResults, PurchaseTypes } from '../../utils/routeParamConstants';
import Screens from '../../screens';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import { PaymentProviders } from '../../utils/paymentProviders';
import store from '../../state/store';

var WebFinishPurchase = /*#__PURE__*/function (_Component) {
  function WebFinishPurchase() {
    var _this2;

    _classCallCheck(this, WebFinishPurchase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _callSuper2(this, WebFinishPurchase, [].concat(args));
    _this2.state = {};
    return _this2;
  }

  _inherits(WebFinishPurchase, _Component);

  return _createClass(WebFinishPurchase, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _store$getState$gameI;

        var token, tid, finishPurchaseArgs, promoLink, response, _this$props, extraParams, ltoPurchase, _this$props2, route, transactionUUID, loyalty, level, coin, gid, remainingParams, trigger, amount, transactionId, loggerParams, _objectSpread2;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                token = this.props.paymentProvider === PaymentProviders.EWAY ? this.props.navigation.getParam('AccessCode', undefined) : this.props.navigation.getParam('token-id', undefined);
                tid = this.props.paymentProvider === PaymentProviders.EWAY ? this.props.transactionId : this.props.navigation.getParam('tid', undefined);
                finishPurchaseArgs = {
                  tid: tid,
                  token: token
                };

                if (this.props.cardNickname) {
                  finishPurchaseArgs.nickname = this.props.cardNickname;
                }

                promoLink = this.props.promoLink;

                if (promoLink && promoLink.active) {
                  finishPurchaseArgs.promocode = promoLink.code;
                }

                finishPurchaseArgs.active_game_id = ((_store$getState$gameI = store.getState().gameInfo) === null || _store$getState$gameI === void 0 ? void 0 : _store$getState$gameI.gameId) || null;
                finishPurchaseArgs.trigger_id = store.getState().purchase.actionTrigger;
                _context.next = 10;
                return ShopInterface.finishWebPurchase(finishPurchaseArgs);

              case 10:
                response = _context.sent;
                _this$props = this.props, extraParams = _this$props.extraParams, ltoPurchase = _this$props.ltoPurchase;
                _this$props2 = this.props, route = _this$props2.route, transactionUUID = _this$props2.transactionUUID, loyalty = _this$props2.loyalty, level = _this$props2.level, coin = _this$props2.coin;
                gid = extraParams.gid, remainingParams = _objectWithoutProperties(extraParams, _excluded);
                QueryParamsProxy.navigate(this.props.navigation, route, {
                  gid: gid
                });
                trigger = Logger.getActionTrigger();
                amount = this.props.navigation.getParam('price', null);
                transactionId = this.props.navigation.getParam('tid', null);
                loggerParams = {
                  type: extraParams.pt === PurchaseTypes.CURRENCY ? 'regular' : 'vip',
                  currency: 'usd',
                  amount: amount,
                  store: 'cams',
                  trigger: trigger,
                  product_id: extraParams.psk,
                  store_tx_id: transactionId,
                  id: transactionUUID,
                  tx_error: response.error,
                  price: this.props.navigation.getParam('price', undefined),
                  currencyPackageId: extraParams[RouteParamConstants.PARAM_PURCHASE_SKU],
                  purchaseType: extraParams[RouteParamConstants.PARAM_PURCHASE_TYPE],
                  promo_code: finishPurchaseArgs.promocode,
                  game_id: gid,
                  product_name: extraParams.packageDetail ? extraParams.packageDetail.NAME : null,
                  loyalty_points: extraParams.packageDetail ? extraParams.packageDetail.BONUS_LOYALTY_AMOUNT : null,
                  loyalty_points_before: loyalty.value,
                  level_after: level,
                  coins: extraParams.packageDetail ? extraParams.packageDetail.AMOUNT : null,
                  promo_coins: extraParams.packageDetail ? extraParams.packageDetail.AMOUNT_INCLUDING_SALE_AND_PROMO : null,
                  balance_before: coin.value
                };

                if (!response.success) {
                  QueryParamsProxy.setQueryParams(_objectSpread(_objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, RouteParamConstants.PARAM_MODAL, Screens.PurchaseFlow), _defineProperty(_objectSpread2, RouteParamConstants.PARAM_PURCHASE_FINISHED_RESULT, response.success ? PurchaseFinishedResults.SUCCESS : PurchaseFinishedResults.ERROR), _defineProperty(_objectSpread2, RouteParamConstants.PARAM_MSG, response.success ? response.msg : response.error), _objectSpread2), remainingParams), {}, {
                    // Remove returned params
                    fix: undefined,
                    price: undefined,
                    tid: undefined,
                    'token-id': undefined
                  })); //Add dive transaction Failed event for web purchase

                  if (amount) {
                    Logger.sendEvent(EVENT_TYPES.TRANSACTION_FAILED, loggerParams);
                  }
                } else {
                  ltoPurchase && this.props.clearLTOOffer();
                  this.props.isOutOfCoinsPurchase(false);
                  this.props.isLTOPurchase(false);
                  this.props.showVipAccessModal(false);
                  QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.PurchaseSucceeded));

                  if (amount) {
                    Logger.sendEvent(EVENT_TYPES.PURCHASE_COMPLETE, loggerParams);
                  }
                }

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      return this.props.render({
        route: this.props.route,
        nickname: this.props.cardNickname
      });
    }
  }]);
}(Component);

export { WebFinishPurchase as default };